import { render, staticRenderFns } from "./CustomerSchedule.vue?vue&type=template&id=1254ea30&"
import script from "./CustomerSchedule.vue?vue&type=script&lang=js&"
export * from "./CustomerSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports